import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { TaskPaymentAttributeEnum } from '@zaoblako/shared/modules/task/enum/task-payment-attribute.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link TaskPaymentAttributeEnum} enumeration values */
export const TaskPaymentAttributeEnumI18n: EnumI18nInterface<TaskPaymentAttributeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [TaskPaymentAttributeEnum.ALL]: 'Все',
    [TaskPaymentAttributeEnum.TRUE]: 'Оплата через кредитные средства',
    [TaskPaymentAttributeEnum.FALSE]: 'Оплата не через кредитные средства',
  },
  [I18nLocalesEnum.EN_US]: {
    [TaskPaymentAttributeEnum.ALL]: 'All',
    [TaskPaymentAttributeEnum.TRUE]: 'Payment via credit funds',
    [TaskPaymentAttributeEnum.FALSE]: 'Payment by non-credit funds',
  },
};
